

export default {
  name: "backgroundStyle",
  nickname: "背景样式",
  desc:
    '每一个柱条的背景样式。需要将 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-bar.showBackground">showBackground</a> 设置为 <code class="codespan">true</code> 时才有效。',
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "柱条的颜色。",
      value: "rgba(180, 180, 180, 0.2)",
      defaultValue: "rgba(180, 180, 180, 0.2)",
      type: "pureValue",
      eType: "color",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "柱条的描边颜色。",
      value: "#000",
      defaultValue: "#000",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "柱条的描边宽度，默认不描边。",
      value: 0,
      defaultValue: 0,
    },
    borderType: {
      name: "borderType",
      nickname: "边框类型",
      desc:
        '柱条的描边类型，默认为实线，支持 <code class="codespan">&#39;dashed&#39;</code>, <code class="codespan">&#39;dotted&#39;</code>。',
      value: "solid",
      defaultValue: "solid",
      type: "pureValue",
    },
    barBorderRadius: {
      name: "barBorderRadius",
      nickname: "圆角半径",
      desc: "",
      value: 0,
      defaultValue: 0,
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
  },
}
